import { render, staticRenderFns } from "./WhInventory.vue?vue&type=template&id=217408d2&scoped=true"
import script from "./WhInventory.vue?vue&type=script&lang=js"
export * from "./WhInventory.vue?vue&type=script&lang=js"
import style0 from "./WhInventory.vue?vue&type=style&index=0&id=217408d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217408d2",
  null
  
)

export default component.exports